// @ts-nocheck
import styled from 'styled-components';

export const GeneralFiltersStyle = styled.div`
`;
